import { render, staticRenderFns } from "./ZoomText.vue?vue&type=template&id=a5e42c1c"
import script from "./ZoomText.vue?vue&type=script&lang=ts"
export * from "./ZoomText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports